<h1 class="u-sr-only">{{ 'Toolkit.Assessment.Assign.Title' | translate }}</h1>
<section class="c-section c-section--first c-section--last c-section--open c-section--static u-no-pb">
	<div class="c-section__content">
		<div class="o-grid">
			<div class="o-grid__cell c-cell">
				<div class="c-card toolkit">
					<loader-overlay *ngIf="vm.loading"></loader-overlay>

					<div class="container container-narrow">
						<button class="btn-back" type="button" (click)="vm.close()">
							<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
							{{ 'Toolkit.Common.Back' | translate }}
						</button>

						<h1>{{ 'Toolkit.Assessment.Assign.Heading' | translate }}</h1>
						<p class="subtitle">
							<span *ngIf="vm.selectedClient">{{ 'Toolkit.Assign.To' | translate }} {{ vm.selectedClient.firstname }} {{ vm.selectedClient.lastname }}</span>
							<span *ngIf="!vm.selectedClient">{{ 'Toolkit.Assessment.Assign.Subtitle' | translate }}</span>
						</p>

						<div class="toolkit__emptyPane" *ngIf="!vm.loading && vm.error">
							<div class="toolkit__emptyTitle">{{ 'Toolkit.Assign.LoadError.Title' | translate }}</div>
							<div class="toolkit__emptyText">{{ 'Toolkit.Assign.LoadError.Text' | translate }}</div>
						</div>

						<ng-container *ngIf="!vm.loading && !vm.error">
							<!-- Step 1: Select client -->
							<div class="assign-step" *ngIf="vm.step === 1">
								<h2 class="step-title"><span class="step-num">1</span> {{ 'Toolkit.Assessment.Assign.Step1.Title' | translate }}</h2>
								<div class="search-box">
									<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#717680" stroke-width="2"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg>
									<input
										type="text"
										placeholder="{{ 'Toolkit.Assign.Client.SearchPlaceholder' | translate }}"
										spellcheck="false"
										[(ngModel)]="vm.clientSearch"
										(ngModelChange)="vm.applyClientFilter()">
								</div>

								<div class="assign-resource-list">
									<div class="assign-resource-item" *ngFor="let c of vm.filteredClients" (click)="vm.selectClient(c)">
										<div class="resource-info">
											<h3>{{ c.firstname }} {{ c.lastname }}</h3>
											<p>{{ c.email || '' }}</p>
										</div>
										<div class="check-circle"></div>
									</div>
								</div>

								<div *ngIf="!vm.filteredClients?.length" class="toolkit__emptyPane">
									<div class="toolkit__emptyTitle">{{ 'Toolkit.Assign.Client.Empty' | translate }}</div>
								</div>
							</div>

							<!-- Step 2: Personalize -->
							<div class="assign-step" *ngIf="vm.step === 2">
								<h2 class="step-title"><span class="step-num">2</span> {{ 'Toolkit.Assessment.Assign.Step2.Title' | translate }}</h2>

								<div class="selected-resource-preview" *ngIf="vm.assessment && vm.questions">
									<div style="display:flex;align-items:center;gap:var(--tk-space-md, 16px);">
										<div class="toolkit__assessmentIcon" aria-hidden="true">
											<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>
										</div>
										<div>
											<div class="font-bold">{{ vm.assessmentCardTitle() }}</div>
											<div class="text-sm text-muted" *ngIf="vm.assessmentCardMeta()">{{ vm.assessmentCardMeta() }}</div>
										</div>
									</div>
								</div>

								<div *ngIf="vm.prior?.length" class="mb-md">
									<div class="card toolkit__priorCard">
										<h3 class="toolkit__priorTitle">{{ 'Toolkit.Assessment.Assign.Prior.Title' | translate }} ({{ vm.prior.length }})</h3>
										<div class="text-sm" *ngFor="let p of vm.prior">
											{{ p.completedAt | date:'yyyy-MM-dd' }} — {{ 'Toolkit.Assessment.Assign.Prior.Score' | translate }}: <strong>{{ p.score }}</strong> ({{ vm.bandLabelFor(p.score) }})
											<span *ngIf="p.isBaseline" class="badge badge-blue">{{ 'Toolkit.Assessment.Assign.Prior.Baseline' | translate }}</span>
										</div>
									</div>
								</div>

								<div class="form-group" *ngIf="vm.isEek2Assessment()">
									<label>Timepoint</label>
									<div style="display:flex;gap:8px;flex-wrap:wrap;">
										<button type="button" class="btn-outline" [disabled]="vm.hasExistingBaseline" [class.btn-primary]="vm.timepoint === 'T1_BASELINE'" (click)="vm.selectTimepoint('T1_BASELINE')">{{ vm.timepointLabel('T1_BASELINE') }}</button>
										<button type="button" class="btn-outline" [class.btn-primary]="vm.timepoint === 'T2'" (click)="vm.selectTimepoint('T2')">{{ vm.timepointLabel('T2') }}</button>
										<button type="button" class="btn-outline" [class.btn-primary]="vm.timepoint === 'T3'" (click)="vm.selectTimepoint('T3')">{{ vm.timepointLabel('T3') }}</button>
										<button type="button" class="btn-outline" [class.btn-primary]="vm.timepoint === 'AD_HOC'" (click)="vm.selectTimepoint('AD_HOC')">{{ vm.timepointLabel('AD_HOC') }}</button>
									</div>
								</div>

								<div class="form-group">
									<label>{{ 'Toolkit.Assign.Note.Label' | translate }}</label>
									<textarea [(ngModel)]="vm.note" placeholder="{{ 'Toolkit.Assign.Note.Placeholder' | translate }}" rows="4"></textarea>
									<p class="form-hint" *ngIf="vm.isEek2Assessment() && vm.timepoint !== 'AD_HOC'">Pre-filled for this timepoint · editable</p>
									<p class="form-hint" *ngIf="!vm.isEek2Assessment() || vm.timepoint === 'AD_HOC'">{{ 'Toolkit.Assign.Note.Hint' | translate }}</p>
								</div>

								<div class="form-group">
									<label>{{ 'Toolkit.Assign.DueDate.Label' | translate }}</label>
									<input type="date" class="form-input" [(ngModel)]="vm.dueAt" [required]="vm.isEek2Assessment() && vm.timepoint !== 'AD_HOC'">
									<p class="form-hint" *ngIf="vm.isEek2Assessment() && vm.timepoint !== 'AD_HOC'">Required for scheduled reassessments</p>
								</div>

								<div class="assign-actions">
									<button class="btn-outline" type="button" (click)="vm.goStep(1)">{{ 'Toolkit.Assign.ChangeClient' | translate }}</button>
									<button class="btn-outline" type="button" (click)="vm.preview()">{{ 'Toolkit.Common.Preview' | translate }}</button>
									<button class="btn-primary" type="button" [disabled]="vm.submitting" (click)="vm.confirmAssignment()">
										{{ vm.submitting ? ('Toolkit.Common.Loading' | translate) : ('Toolkit.Assessment.Assign.Confirm' | translate) }}
									</button>
								</div>
							</div>

							<!-- Step 3: Confirmed -->
							<div class="assign-step" *ngIf="vm.step === 3">
								<div class="success-state">
									<div class="success-icon">
										<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#287638" stroke-width="2"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>
									</div>
									<h2>{{ 'Toolkit.Assign.Done.Title' | translate }}</h2>
									<p class="text-muted">{{ 'Toolkit.Assessment.Assign.Done.Text' | translate }}</p>
									<div class="assign-actions" style="justify-content:center;">
										<button class="btn-outline" type="button" (click)="vm.close()">{{ 'Toolkit.Assign.Done.Back' | translate }}</button>
									</div>
								</div>
							</div>
						</ng-container>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
